import BackgroundVideo from '../components/BackgroundVideo';

export default class ModFullWidthLongImageSocialGrid {
  constructor(e) {
    this.$this = $(e);
    this.$videos = this.$this.find('.video-iframe-wrapper');
    this.$modSocialGrid = $('.mod-social-grid');
    this.clsLongImage = '.long-image';
    this.positionFlag = 0;
    this.init();
  }

  init() {
    this.getHeightModule();
    this.setHiddenItem(this.$this, 15, 'md:hidden');
    this.setHiddenItem(this.$modSocialGrid, 10, 'hidden');
    this.callLoadVideo();
    this.addListeners();
  }

  addListeners() {
    $(window).on('resize', () => {
      this.getHeightModule();
    });
  }

  callLoadVideo() {
    if (this.$videos.length) {
      this.$videos.each((_i, e) => {
        new BackgroundVideo(e).init();
      });
    }
  }

  setHiddenItem($mod, numberItem, clsHidden) {
    let count = 0;
    let countMobile = 0;
    $mod.find(this.clsLongImage).each((_i, e) => {
      count++;
      countMobile++;
      if ($(e).hasClass('vertical-rectangle-dt') || $(e).hasClass('horizontal-rectangle-dt')) {
        count++;
        countMobile++;
      }
      if (!$(e).hasClass('hidden-mobile') && $(e).hasClass('horizontal-rectangle-mb')) {
        $(e).parent().addClass('horizontal-has');
      }
      if (count > numberItem) {
        $(e).addClass(clsHidden);
      }
      if ($(e).hasClass('hidden-mobile')) {
        countMobile--;
      }
    });
    if ($mod.hasClass('mod-social-grid')) {
      const $listItemImage = $mod.find('.long-image-list');
      if (count <= 5) {
        $listItemImage.removeClass('md:grid-rows-2');
        $listItemImage.addClass('md:grid-rows-1');
      }
      if (countMobile <= 4) {
        $listItemImage.removeClass('grid-rows-3');
        $listItemImage.addClass('grid-rows-2');
      }
    }
  }

  getHeightModule() {
    const $thisHeight = this.$this.innerHeight();
    const $windowHeight = $(window).innerHeight();
    if ($thisHeight > $windowHeight) {
      this.$this.attr('data-scroll-offset', $thisHeight - $windowHeight + 350);
    } else {
      this.$this.attr('data-scroll-offset', '1300');
    }
  }

  handleEvtStopOrStartScroll() {
    window.scrollAgent.scrollEvent((args) => {
      const scrollY = parseFloat(args.scroll.y.toFixed(2));
      if (this.positionFlag !== scrollY) {
        this.positionFlag = scrollY;
        const $locoScrollSection = $('.loco-scroll-section');
        if (this.$this.find('.list-long-image').hasClass('set-animation')) {
          setTimeout(() => {
            const transform3DSection = this.$this.css('transform');
            this.$this.addClass('transform-section');

            $(`<style type="text/css">.transform-section {transform: ${transform3DSection}!important;</style>`).appendTo(
              $('head'),
            );
          }, 2000);

          setTimeout(() => {
            const tl1 = Math.abs(parseInt($locoScrollSection.css('transform').split(',')[5], 10));
            const tl2 = Math.abs(parseInt(this.$this.css('transform').split(',')[5], 10));
            $(
              `<style type="text/css">.transform-section {transform: matrix(1, 0, 0, 1, 0, 0)!important</style>`,
            ).appendTo($('head'));
            const tl3 = tl1 - tl2;
            $locoScrollSection.css('transform', `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -${tl3}, 0, 1)`);
          }, 3000);
        }
      }
    });
  }
}
